export * from "./pdf";

export const FORCE_AUTH = process.env.REACT_APP_FORCE_AUTH === "true";